/**
 * @fileoverview Nome traduzido da categoria de um template da Meta (Marketing,
 * Utilitário, Autenticação). Resolvido na hora de desenhar, para seguir a troca
 * de idioma. Usado pelo modal "Selecionar Template" e pelas abordagens
 * inteligentes.
 */

import { i18n } from "../translate/i18n";

export const templateCategoryLabel = (category) => {
  switch (category) {
    case "MARKETING":
      return i18n.t("templateModal.categories.marketing");
    case "UTILITY":
      return i18n.t("templateModal.categories.utility");
    case "AUTHENTICATION":
      return i18n.t("templateModal.categories.auth");
    default:
      return category || i18n.t("templateModal.categories.other");
  }
};
